var _styled;

// https://govuk-elements.herokuapp.com/alpha-beta-banners/
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
import { BLUE } from 'govuk-colours';
import { FONT_SIZE, LINE_HEIGHT, MEDIA_QUERIES, NTA_LIGHT } from '@govuk-react/constants';
import { withWhiteSpace } from '@govuk-react/hoc';
import PhaseBadge from '@govuk-react/phase-badge';
var StyledBanner = styled('div')((_styled = {
  borderBottom: '1px solid #bfc1c3',
  boxSizing: 'border-box',
  paddingTop: '10px',
  paddingBottom: '10px',
  fontFamily: NTA_LIGHT,
  fontWeight: 400,
  textTransform: 'none',
  fontSize: FONT_SIZE.SIZE_14,
  lineHeight: LINE_HEIGHT.SIZE_14
}, _styled[MEDIA_QUERIES.LARGESCREEN] = {
  fontSize: FONT_SIZE.SIZE_16,
  lineHeight: LINE_HEIGHT.SIZE_16
}, _styled['> a'] = {
  color: BLUE
}, _styled));

var PhaseBanner = function PhaseBanner(_ref) {
  var level = _ref.level,
      children = _ref.children,
      className = _ref.className;
  return React.createElement(StyledBanner, {
    className: className
  }, React.createElement(PhaseBadge, null, level), children);
};

PhaseBanner.defaultProps = {
  className: undefined
};
PhaseBanner.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node.isRequired,
  level: PropTypes.string.isRequired,
  className: PropTypes.string
} : {};
export default withWhiteSpace({
  marginBottom: 0
})(PhaseBanner);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@govuk-react/phase-banner/es/index.js
// module id = 89
// module chunks = 0